export default "__VITE_PUBLIC_ASSET__cef8e5d5__"